import React, { useState, useEffect } from 'react';
import { getHomeData } from './api';
import { CalendarIcon, CakeIcon, FlagIcon, UsersIcon, LightningBoltIcon, DocumentTextIcon } from '@heroicons/react/outline';

const Home = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentUserRole = localStorage.getItem('role_id');
  useEffect(() => {
    getHomeData()
      .then(json => { setData(json); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  if (loading) return <div className="container mx-auto p-6">Loading...</div>;
  if (error) return <div className="container mx-auto p-6 text-red-600">Error: {error}</div>;

  const { approvedLeaves, pendingLeaves, birthdays, publicHolidays, teamEvents, quickActions, recentDocuments, teammateOnLeaveToday, employeeOnLeaveToday } = data;

  return (
    <div className="container mx-auto px-6 py-4 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-semibold mb-6">My Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-green-500">
          <div className="flex items-center mb-4">
            <CalendarIcon className="h-6 w-6 text-green-500 mr-2" />
            <h2 className="text-xl font-medium">Leave Snapshot</h2>
          </div>
          {approvedLeaves.length > 0 && <h3 className="font-semibold mt-2">Upcoming Approved</h3>}
          <ul className="list-disc list-inside space-y-2 mb-4">
            {approvedLeaves.map(leave => (
              <li key={leave.id}>{leave.type}: {leave.startDate} to {leave.endDate}</li>
            ))}
          </ul>
          {pendingLeaves.length > 0 && <h3 className="font-semibold mt-4">Pending Requests</h3>}
          <ul className="list-disc list-inside space-y-2">
            {pendingLeaves.map(leave => (
              <li key={leave.id}>{leave.type}: {leave.startDate} to {leave.endDate}</li>
            ))}
          </ul>
        </section>
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-green-500">
          <div className="flex items-center mb-4">
            <UsersIcon className="h-6 w-6 text-green-500 mr-2" />
            <h2 className="text-xl font-medium">Teammate on Leave Today</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {teammateOnLeaveToday.map((member, idx) => (
              <li key={idx}>{member.name} {member.leave_type}</li>
            ))}
          </ul>
        </section>
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-pink-500">
          <div className="flex items-center mb-4">
            <CakeIcon className="h-6 w-6 text-pink-500 mr-2" />
            <h2 className="text-xl font-medium">Birthdays This Week</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {birthdays.map(person => (
              <li key={person.id}>{person.name} - {person.date}</li>
            ))}
          </ul>
        </section>
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-blue-500">
          <div className="flex items-center mb-4">
            <FlagIcon className="h-6 w-6 text-blue-500 mr-2" />
            <h2 className="text-xl font-medium">Public Holidays</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {publicHolidays.map(holiday => (
              <li key={holiday.id}>{holiday.name} - {holiday.date}</li>
            ))}
          </ul>
        </section>
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-purple-500">
          <div className="flex items-center mb-4">
            <UsersIcon className="h-6 w-6 text-purple-500 mr-2" />
            <h2 className="text-xl font-medium">Team Events</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {teamEvents.map(event => (
              <li key={event.id}>{event.title} - {event.date}</li>
            ))}
          </ul>
        </section>
        
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-indigo-500">
          <div className="flex items-center mb-4">
            <DocumentTextIcon className="h-6 w-6 text-indigo-500 mr-2" />
            <h2 className="text-xl font-medium">Recent Documents</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {recentDocuments.map(doc => (
              <li key={doc.id}><a href={doc.url}>{doc.name}</a></li>
            ))}
          </ul>
        </section>
        
        
        {(currentUserRole == 1 || currentUserRole == 3) && (
        <section className="bg-white shadow rounded-lg p-6 border-l-4 border-indigo-500">
          <div className="flex items-center mb-4">
            <DocumentTextIcon className="h-6 w-6 text-indigo-500 mr-2" />
            <h2 className="text-xl font-medium">Employee on Leave Today</h2>
          </div>
          <ul className="list-disc list-inside space-y-2">
            {employeeOnLeaveToday.map((member, idx) => (
              <li key={idx}>{member.name} {member.leave_type}</li>
            ))}
          </ul>
        </section>
        )}
        
      </div>
    </div>
  );
};

export default Home;
